import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
    pure: true,
    standalone: false
})
export class PhonePipe implements PipeTransform {
  /**
   * Formats phone numbers in the Brazilian standard.
   * - 13 digits (BR): 55 + DDD(2) + subscriber(9)  -> +55 (61) 99859-9327
   * - 12 digits (BR): 55 + DDD(2) + subscriber(8)  -> +55 (61) 8330-7454
   */
  transform(value: string | number | null | undefined): string {
    if (!value) return '';

    const digits = String(value).replace(/\D+/g, '');
    if (!/^55\d{10,11}$/.test(digits)) return '';

    const country = digits.slice(0, 2);
    const area = digits.slice(2, 4);
    const subscriber = digits.slice(4).replace(
      digits.length === 13 ? /(\d{5})(\d{4})/ : /(\d{4})(\d{4})/,
      '$1-$2'
    );

    return `+${country} (${area}) ${subscriber}`;
  }
}
